export default __webpack_public_path__ + "static/media/anthracite.9f1a057d.webp";